import React from 'react';

export const SurveyModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-primaryBlack bg-opacity-40 backdrop-blur-sm">
      <div className="relative bg-white rounded-2xl w-[95%] max-w-4xl h-[85%] shadow-2xl border border-gray-200 overflow-hidden animate-fadeIn">
        
        {/* Close Button */}
        <button
          className="absolute top-2 right-3 text-gray-600 hover:text-black text-2xl font-bold z-10"
          onClick={onClose}
        >
          ✕
        </button>

        {/* Survey Iframe */}
        <iframe
          src="https://app.surveyconstructor.com/surveys/2a29b1e5-9993-4128-b592-181d381683b5/participate"
          width="100%"
          height="100%"
          frameBorder="0"
          className="rounded-b-2xl"
        ></iframe>
      </div>
    </div>
  );
};
